export default [
  {
    path: "/raportakimhedefaylik",
    name: "raportakimhedefaylik",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "raportakimhedefaylik.Baslik",
      yetki: { k: [2001702] },
    },
  },
]
